export const isBrowser = typeof window !== 'undefined';
export const RootLabel = '__root__';
export const defaultLogOptions = {
    enabled: true,
    showTimeStamp: true,
    useTimeDelta: false,
    useColor: true,
    stringProviderMethodName: 'toLogInfo',
};
export const state = (() => {
    const root = {
        timestamp: new Date(),
        label: RootLabel,
        children: [],
    };
    return {
        hasWarned: false,
        options: defaultLogOptions,
        root,
        head: root,
    };
})();
//# sourceMappingURL=constTypes.js.map